import { BackToBackChoice } from "./BackToBackOption.types";

export const BACK_TO_BACK_CHOICES: BackToBackChoice[] = [
  "reading then meaning",
  "meaning then reading",
  "disabled",
];
